<template>
  <div>
    <form enctype="multipart/form-data" novalidate>
      <div class="dropbox">
        <input
          type="file"
          accept="image/jpeg,image/jpg,image/tif,image/tiff,image/png,image/gif,image/svg+xml,image/vnd.adobe.photoshop,
            video/*,
            application/*,text/*,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-powerpoint,
            audio/*,
            video/avi"
          multiple
          name="files"
          @input="saveFiles($event.target.files); $event.target.reset;"
          class="input-file"
        />
        <div class="w-full py-5 flex items-center justify-center">
          <FileUploadDropdownIcon class="h-1/6 w-1/6 mr-5" />
          <div class="tm-mt-6 tm-text-center">
            <span class="hidden mb-3 md:block leading-tight text-lg font-semibold text-yankFire">
              Drag files here
              <span class="text-payne text-xs font-light ml-2 mt-2">or</span>
            </span>
            <label class="h-11 border rounded-xl font-semibold text-sm focus:outline-none px-6 flex items-center hover:opacity-80 select-none bg-aquamarine border-aquamarine text-white cursor-pointer">
              Select From Computer
            </label>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import FileUploadDropdownIcon from '@/components/svg/FileUploadDropdownIcon.vue';

export default {
  name: "UploadSection",
  components: {
    FileUploadDropdownIcon
  },
  props: {
    uploadErrors: Object,
    uploadSuccess: Object,
    folderId: {type: Number, default: 0},
  },
  data() {
    return {
      uploadedFiles: [],
      fileCount: 0,
      requestCount: 0,
    };
  },
  methods: {
    reset() {
      this.fileCount = 0;
    },
    close() {
      this.$emit("close", this.uploadedFiles);
    },
    isValidFilename(filename) {
      var regex = /^[^{}]+$/;
      return regex.test(filename);
    },
    saveFiles(files) {
      this.isSaving = true;
      this.reset();

      let hasInvalidFiles = false;
      Object.values(files).forEach((file) => {
        if(!this.isValidFilename(file.name)) {
          this.isSaving = false;
          hasInvalidFiles = true;
          return;
        }
      });

      if(hasInvalidFiles) {
        this.$toast.error("You're trying to upload files with invalid names. Check your selected files and make sure you're not using special characters and try again!");
        return;
      }

      Object.values(files).forEach((file) => {
        const fileCount = this.fileCount;
        const fileName = file.name;
        this.uploadedFiles.push({ request_id: fileCount, name: fileName, file: file });
        this.fileCount++;
      });

      const firstFile = this.uploadedFiles[this.requestCount];
      this.close();
      this.save(firstFile.file, firstFile.name, 0);
    },

    save(file, name, requestCount) {
      try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("name", name);
        formData.append("request_id", requestCount);
        if(this.folderId !== 0) {
          formData.append("folder_id", this.folderId);
        }
        this.$inertia.post(this.$route("church-media.items.store"), formData, {
          preserveScroll: true,
          onFinish: () => {
            requestCount++;
            if(this.uploadedFiles.length > requestCount) {
              const nextFile = this.uploadedFiles[requestCount];
              this.save(nextFile.file, nextFile.name, requestCount);
            } else {
              this.uploadedFiles = [];
            }
          },
        });
      } catch (ex) {
        console.log(ex);
      }
    },
  },
  mounted() {
    this.reset();
  },
};
</script>

<style lang="scss">
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  background: #F7FAFC;
  color: dimgray;
  position: relative;
  cursor: pointer;
  border-radius: 10px;
  transition: background-color 2.5s ease;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>